// AUTO-GENERATED by scripts/generate-stavajici-zafuk-bundles-from-excel.mjs — do not edit by hand.

export interface StavajiciBundleMaterialLine {
  sapCode: string;
  quantity: number;
}

export interface StavajiciZafukBundle {
  id: string;
  label: string;
  lines: readonly StavajiciBundleMaterialLine[];
}

export const STAVAJICI_ZAFUK_BUNDLES: readonly StavajiciZafukBundle[] = [
  {
    id: "stavajici-zafuk-10x7",
    label: "Záfuk 10x7",
    lines: [
      { sapCode: "300623", quantity: 1 },
      { sapCode: "300624", quantity: 1 },
      { sapCode: "300625", quantity: 1 },
      { sapCode: "300626", quantity: 1 },
      { sapCode: "300627", quantity: 1 },
      { sapCode: "300628", quantity: 1 },
      { sapCode: "300629", quantity: 1 },
      { sapCode: "300630", quantity: 1 },
      { sapCode: "300631", quantity: 1 },
      { sapCode: "300632", quantity: 1 },
    ],
  },
  {
    id: "stavajici-zafuk-10x5",
    label: "Záfuk 10x5",
    lines: [
      { sapCode: "300633", quantity: 1 },
      { sapCode: "300634", quantity: 1 },
      { sapCode: "300635", quantity: 1 },
      { sapCode: "300636", quantity: 1 },
      { sapCode: "300637", quantity: 1 },
    ],
  },
  {
    id: "stavajici-zafuk-3x10-4x7",
    label: "Záfuk 3x10 + 4x7",
    lines: [
      { sapCode: "300633", quantity: 1 },
      { sapCode: "300634", quantity: 1 },
      { sapCode: "300635", quantity: 1 },
      { sapCode: "300623", quantity: 1 },
      { sapCode: "300624", quantity: 1 },
      { sapCode: "300625", quantity: 1 },
      { sapCode: "300626", quantity: 1 },
    ],
  },
] as const;
